import React, { useContext } from 'react';

const FirebaseContext = React.createContext(null);

export function useFirebase() {
  const firebase = useContext(FirebaseContext);
  if (!firebase) {
    throw new Error('useFirebase must be used within a FirebaseContext.Provider');
  }
  return firebase;
}

export default FirebaseContext;
